import { cardMediaClasses } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useImageUploadStyles = makeStyles(({ spacing, palette }) => {
  const sharedCardMedia = {
    [`& .${cardMediaClasses.root}`]: {
      objectFit: 'fill',
    },
  };
  return createStyles({
    divider: {
      marginLeft: spacing(3),
      marginRight: spacing(3),
      background: palette.divider,
    },
    deleteIcon: {
      float: 'right',
      padding: 0,
    },
    previewTitle: {
      borderBottom: `${spacing(0.2)} solid ${palette.divider}`,
      padding: spacing(2),
    },
    previewCard: {
      marginTop: spacing(2),
      borderTop: `${spacing(0.2)} solid ${palette.divider}`,
      ...sharedCardMedia,
    },
    wrapper: {
      flexGrow: 1,
      padding: spacing(2),
    },
    contentLeftLayout: {
      float: 'left',
    },
    contentRightLayout: {
      float: 'right',
    },
    or: {
      marginBottom: spacing(2),
    },
    fileName: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      lineHeight: 'normal',
      textTransform: 'capitalize',
    },

    imageCardView: {
      '&:hover $deleteBtn': {
        display: 'block',
      },
      ...sharedCardMedia,
    },
    deleteBtn: {
      display: 'none',
      float: 'right',
    },
    contentWrapper: {
      display: 'flex',
      height: spacing(125),
    },
    dropZone: {
      flex: '35%',
      paddingTop: spacing(3),
      paddingBottom: spacing(3),
    },
    listFiles: {
      flex: '65%',
    },
    emptyContent: {
      display: 'flex',
      justifyContent: 'center',
      alignSelf: 'center',
      '& > *': {
        margin: spacing(),
      },
    },
    btnText: {
      color: palette.common.black,
    },
    imageContentWrapper: {
      paddingRight: spacing(2),
    },
    selectedImage: {
      border: `${spacing(0.5)} solid ${palette.secondary.main}`,
    },
    selectedImageIcon: {
      position: 'absolute',
      color: palette.secondary.main,
      top: spacing(1),
      right: spacing(1),
    },
    nonWimImageDark: {
      background:
        palette.mode === 'light'
          ? palette.common.white
          : 'linear-gradient(0deg, rgba(34,34,34,1) 0%, rgba(34,34,34,1) 0%, rgba(153,153,153,1) 0%, rgba(153,153,153,1) 100%)',
    },
  });
});
export default useImageUploadStyles;
